import "./index.css";
import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { CtaBlock } from '@design-system/cta-block';
import { Icon } from '@design-system/icon';
import { Typography } from '@design-system/typography';
import { Modal } from '@phx-husky/modal';
import classNames from 'classnames';
import { forwardRef } from 'react';
var Dialog = forwardRef(function (_ref) {
  var className = _ref.className,
    isShowing = _ref.isShowing,
    close = _ref.close,
    closeModal = _ref.closeModal,
    disableOnClickClose = _ref.disableOnClickClose,
    title = _ref.title,
    description = _ref.description,
    closeAriaLabel = _ref.closeAriaLabel,
    primaryButtonLabel = _ref.primaryButtonLabel,
    primaryButtonAriaLabel = _ref.primaryButtonAriaLabel,
    secondaryButtonLabel = _ref.secondaryButtonLabel,
    secondaryButtonAriaLabel = _ref.secondaryButtonAriaLabel,
    _ref$closeIconSize = _ref.closeIconSize,
    closeIconSize = _ref$closeIconSize === void 0 ? 'large' : _ref$closeIconSize,
    onPrimaryButtonClick = _ref.onPrimaryButtonClick,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? true : _ref$showOverlay,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$iconType = _ref.iconType,
    iconType = _ref$iconType === void 0 ? 'tooltip' : _ref$iconType;
  return jsx(Modal, Object.assign({
    isShowing: isShowing,
    close: close,
    disableOnClickClose: disableOnClickClose,
    className: classNames('cds-dialog-window', className, {
      'cds-dialog-window__inverse': mode !== 'default'
    }),
    ariaLabel: title,
    showOverlay: showOverlay
  }, {
    children: jsxs("div", Object.assign({
      className: "cds-dialog-window__content"
    }, {
      children: [showCloseButton && closeAriaLabel ? jsx("div", Object.assign({
        className: "cds-dialog-window__close-button-container"
      }, {
        children: jsx(Button, Object.assign({
          className: "cds-dialog-window__close-button",
          "aria-label": closeAriaLabel,
          onClick: function onClick() {
            return closeModal();
          },
          variant: "subtle-icon",
          iconPrefix: {
            props: {
              icon: 'close'
            }
          },
          size: closeIconSize,
          autoFocus: true
        }, {
          children: closeAriaLabel
        }))
      })) : null, showIcon ? jsx("div", Object.assign({
        className: "cds-dialog-window__icon-container"
      }, {
        children: jsx(Icon, {
          size: 32,
          className: "cds-dialog-window__icon",
          icon: iconType
        })
      })) : null, title ? jsx(Typography, {
        className: "cds-dialog-window__title",
        tag: "h3",
        weight: "bold",
        variant: "headline",
        size: "m",
        content: title
      }) : null, description ? jsx(Typography, {
        className: "cds-dialog-window__description",
        tag: "p",
        variant: "body",
        size: "m",
        content: description
      }) : null, jsx("div", Object.assign({
        className: classNames('cds-dialog-window__button-container')
      }, {
        children: jsx(CtaBlock, {
          data: [{
            elementType: 'button',
            variant: 'primary',
            size: 'large',
            children: primaryButtonLabel,
            className: 'cds-dialog-window__button',
            onClick: onPrimaryButtonClick,
            'aria-label': primaryButtonAriaLabel
          }, {
            elementType: 'button',
            variant: 'secondary',
            size: 'large',
            onClick: closeModal,
            children: secondaryButtonLabel,
            className: 'cds-dialog-window__button',
            'aria-label': secondaryButtonAriaLabel
          }]
        })
      }))]
    }))
  }));
});
export { Dialog };